// AccountPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AddProductForm from '../components/AddProductForm';
import ProductCard from '../components/ProductCard';
import "./AccountPage.css"

const AccountPage = ({ user }) => {  // Принимаем `user` как пропс из App.js
  const [userData, setUserData] = useState(null);
  const [userProducts, setUserProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchAccountData = async () => {
    try {
      const response = await axios.get('/api/account', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setUserData(response.data.user);
      setUserProducts(response.data.products);
    } catch (error) {
      console.error('Ошибка при получении данных аккаунта:', error);
      navigate('/auth'); // Перенаправляем на страницу авторизации при ошибке
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (user && token) {
      fetchAccountData();
    } else {
      navigate('/auth');
    }
  }, [user, navigate]);


  if (loading) return <div>Загрузка...</div>;

  return (
    <div className='account'>
      <h1>Личный кабинет</h1>
      {userData && (
    <div className='infoBlock'>
      <h2>Добро пожаловать в свой личный кабинет</h2>
      <h3>Здесь вы можете управлять своим профилем и следить за статусами</h3>

      <p><strong>Email аккаунта:</strong> {userData.email}</p>
      <p><strong>Ваш баланс:</strong> {userData.balance} ₽</p>

      <p>
        <strong>Оплата и пополнение баланса:</strong><br />
        В данный момент автоматическое пополнение временно недоступно. Для пополнения баланса, пожалуйста, свяжитесь с нашей поддержкой в Telegram:
        <a href='https://t.me/xbIllion007' target='_blank' rel='noopener noreferrer'> @xbIllion007</a>
      </p>

      <p>
        <strong>Описание статусов анкеты:</strong>
        <ul>
          <li><strong>Обычный</strong> – ваша анкета отображается наравне со всеми остальными в общем списке.</li>
          <li><strong>Стандарт</strong> – анкета выделяется <span style={{ color: 'green' }}>зелёным</span> цветом и показывается выше, чем обычные анкеты. Срок действия: 7 дней. По истечении срока автоматически возвращается в статус "Обычный".</li>
          <li><strong>Премиум</strong> – анкета выделяется <span style={{ color: 'red' }}>красным</span> цветом и показывается выше, чем "Обычные" и "Стандарт" анкеты. Срок действия: 30 дней.</li>
        </ul>
      </p>

      <p>
        Если возникли вопросы – пишите в нашу поддержку в Telegram:
        <a href='https://t.me/xbillionjob' target='_blank' rel='noopener noreferrer'> @xbillionjob</a>
      </p>
    </div>
  )}

      <h2>Мои анкеты</h2>
      {userProducts.length > 0 ? (
        <div className="product-list">
          {userProducts.map((product) => (
            <ProductCard key={product.id} product={product} onUpdate={fetchAccountData} />
          ))}
        </div>
      ) : (
        <p>У вас пока нет анкет</p>
      )}


      <AddProductForm onUpdate={fetchAccountData} />
    </div>
  );
};

export default AccountPage;
